Ext.define('SA.view.AdHocNotice', {
    alias: 'widget.ad-hoc-notice',
    extend: 'SA.view.PromptWindow',

    cls: 'sa-ad-hoc-notice',
    includeHeader: false,
    includeOkBtn: true,

    getBodyItems() {
        var isWarning = this.notice.isWarning(),
            iconCls = isWarning ? 'sa-ad-hoc-notice-svg-warning' : 'sa-ad-hoc-notice-svg-info',
            iconHref = isWarning ? '#sa-icon-warning' : '#sa-icon-map-info',
            messageHtml = this.notice.getMessageHtml();

        return {
            xtype: 'component',
            cls: 'sa-ad-hoc-notice-message-wrap',

            html: [
                `<svg class="sa-ad-hoc-notice-svg ${iconCls}"><use href="${iconHref}"></use></svg>`,
                `<div class="sa-ad-hoc-notice-message">${messageHtml}</div>`
            ]
        };
    },

    onDestroy() {
        this.notice.markViewed();

        this.callParent();
    }
});